class Math {
  static round (value, places = 15) {
    return parseFloat(parseFloat(value).toFixed(places)).toFixed(places)
  }

  static normalize (value = '') {
    let retorno = value

    let lastDot = retorno.toString.lastIndexOf(',')

    let integerPart = retorno.substr(0, lastDot).replace(',', '')
    let decimalPart = retorno.substr(lastDot + 1)

    return integerPart + '.' + decimalPart
  }

  static parseBD (value) {
    return this.round(this.normalize(value))
  }
}

export default Math



// WEBPACK FOOTER //
// ./src/classes/math.js